import TranslationOld from "./translation_old_cs.js";
import {concat, forEach, isEmpty} from "lodash";
import {Button} from "react-md";
import React from "react";
import {getRequestById} from "../../actions/requestActions";

// zatim jedna instance
// 1. zobraz co tu ma spravne byt
// 2. at to klika jak ma

function log()
{
    console.log.apply( null, concat( ['%cRequestModelOld', 'color:white;background:#0067b8;'], arguments ));
}


const CommandGroups =
{
    getButtonsForGroup: function( stateKey )
    {
        log( {stateKey});


        // CREATE_PROVIDER request button

        // INVITE_PROVIDER

        let buttonArray2ReactButtonArray = ( buttonArray, buttonClassName ) =>
        {
            let array = null;
            if( ! isEmpty( buttonArray ))
            {
                array = [];
                forEach( buttonArray, ( item, uniqueKey ) => {
                    array.push((
                        <Button
                            key={uniqueKey}
                            raised
                            className={"btn btn-primary " + buttonClassName }
                            label={item.label}
                            onClick={item.onClick}
                        />
                    ));
                });
            }
            return array;
        };

        const actionList = this._data()[ stateKey ];
        log( { actionList });

        let leftButtons = [];
        let rightButtons = [];
        forEach( actionList, ( actionInfo, uniqueKey ) =>
        {
            log( { actionInfo } );
            let pushTarget = null;
            if( actionInfo.default )
            {
                pushTarget = rightButtons;
            }
            else
            {
                pushTarget = leftButtons;
            }

            const buttonClassName = actionInfo.default? 'touchButton-6' : 'touchButton-5';
            const label = TranslationOld.getTranslationForKey( actionInfo.transKey );
            const newRequestData = Commands.commandFromAction( actionInfo.id );
            const onclick = () => {

                log( newRequestData );

                // setActiveForm( "requestContentForm", {
                //     formData: newRequestData,
                //     // primaryButtonLabel: "Znovu předat"
                // } );
                // getRequestById( match.params.id );
            };
            pushTarget.push( <Button
                key={uniqueKey}
                raised
                className={"btn btn-primary " + buttonClassName }
                label={label}
                onClick={onclick}
            /> );
        });

        return {
            leftButtons,
            rightButtons
        }
    },

    // for state
    _data: function()
    {
        // state id => [ buttons { button id, translation, default? } ]

        return {
            //<div className="header status">
                "initialRecipientYour": [// <div className="buttonBar initialRecipientYour">
                    { "id": "reject", "transKey": "button.reject", "transDefault": "Reject" }, // <button className="button reject" data-i18n="button.reject">Reject</button>
                    { "id": "return", "transKey": "button.return", "transDefault": "Return" }, // <button className="button return" data-i18n="button.return">Return</button>
                    { "id": "accept", "transKey": "button.accept", "transDefault": "Accept", "default": true }, // <button className="button default single accept" data-i18n="button.accept">Accept</button>
                // </div>
                ], "initialRecipientTheir": [ // <div className="buttonBar initialRecipientTheir">
                    { "id": "close", "transKey": "button.closeRequest", "transDefault": "Close" }, // <button className="button close single" data-i18n="button.closeRequest">Close</button>
                // </div>
                ], "initialSenderYour": [ // <div className="buttonBar initialSenderYour">
                    { "id": "close", "transKey": "button.closeRequest", "transDefault": "Close" }, // <button className="button close single" data-i18n="button.closeRequest">Close</button>
                    { "id": "resubmit", "transKey": "button.resubmit", "transDefault": "Resubmit", "default": true }, // FIXME: <button className="button default single resubmit" data-i18n="button.resubmit">Resubmit</button>
                // </div>
                ], "acceptedRecipientYour": [ // <div className="buttonBar acceptedRecipientYour">
                    { "id": "return", "transKey": "button.return", "transDefault": "Return" }, // <button className="button return" data-i18n="button.return">Return</button>
                    { "id": "dismiss", "transKey": "button.dismiss", "transDefault": "Dismiss" }, // <button className="button dismiss" data-i18n="button.dismiss">Dismiss</button>
                    { "id": "resolving", "transKey": "button.resolving", "transDefault": "Resolved", "default": true }, // FIXME: <button className="button default single resolving" data-i18n="button.resolving">Resolved</button>
                // </div>
                ], "acceptedSenderYour": [ // <div className="buttonBar acceptedSenderYour">
                    { "id": "resolved", "transKey": "button.resolved", "transDefault": "Resolved" }, // <button className="button other resolved single" data-i18n="button.resolved">Resolved</button>
                    { "id": "resubmit", "transKey": "button.resubmit", "transDefault": "Resubmit", "default": true }, // FIXME: <button className="button default single resubmit" data-i18n="button.resubmit">Resubmit</button>
                // </div>
                ], "acceptedSenderTheir": [ // <div className="buttonBar acceptedSenderTheir">
                    { "id": "dismiss", "transKey": "button.dismiss", "transDefault": "Dismiss" }, // <button className="button dismiss single" data-i18n="button.dismiss">Dismiss</button>
                    { "id": "resolving", "transKey": "button.resolving", "transDefault": "Resolved", "default": true }, // FIXME: <button className="button default single resolving" data-i18n="button.resolving">Resolved</button>
                // </div>
                ], "resolvingRecipientYour": [ // <div className="buttonBar resolvingRecipientYour">
                    { "id": "dismiss", "transKey": "button.dismiss", "transDefault": "Dismiss" }, // <button className="button dismiss single" data-i18n="button.dismiss">Dismiss</button>
                    { "id": "resolving", "transKey": "button.resolving", "transDefault": "Resolved", "default": true }, // FIXME: <button className="button default single resolving" data-i18n="button.resolving">Resolved</button>
                // </div>
                ], "resolvingSenderYour": [ // <div className="buttonBar resolvingSenderYour">
                    { "id": "notSolved", "transKey": "button.notSolved", "transDefault": "Not Solved" }, // <button className="button notSolved single" data-i18n="button.notSolved">Not Solved</button>
                    { "id": "resolved", "transKey": "button.resolved", "transDefault": "Resolved", "default": true }, // FIXME: <button className="button default single resolved" data-i18n="button.resolved">Resolved</button>
                // </div>
                ], "createProvider.resolved": [ // <div className="buttonBar createProvider resolved">
                    { "id": "setup", "transKey": "createOrganization.button.setup", "transDefault": "Organization's Setup" },
                    // FIXME: <button className="button single setup" type="button"
                    //        data-i18n="createOrganization.button.setup">Organization's Setup
                    //</button>
                    { "id": "home", "transKey": "createOrganization.button.home", "transDefault": "Organization's Home", "default": true },
                    //<button className="button single default home" type="button"
                    //        data-i18n="createOrganization.button.home">Organization's Home
                    //</button>
                // </div>
                ], "createProject.resolved": [ // <div className="buttonBar createProject resolved">
                    { "id": "detail", "transKey": "button.projectDetail", "transDefault": "Project Detail", "default": true },
                    //<button className="button single default detail" type="button"
                    //        data-i18n="button.projectDetail">Project Detail
                    //</button>
                // </div>
                ], "inviteProvider.recipient": [ // <div className="buttonBar inviteProvider recipient">
                    { "id": "rejectInvite", "transKey": "button.reject", "transDefault": "Reject" },
                    //<button className="button single rejectInvite" type="button"
                    //        data-i18n="button.reject">Reject
                    //</button>
                    { "id": "suggest", "transKey": "button.suggestOther", "transDefault": "Suggest Other" },
                    //<button className="button single suggest" type="button"
                    //        data-i18n="button.suggestOther">Suggest Other
                    // </button>
                    { "id": "acceptInvite", "transKey": "button.accept", "transDefault": "Accept", "default": true },
                    // <button className="button single default acceptInvite" type="button"
                    //        data-i18n="button.accept">Accept
                    // </button>
                // </div>
                ], "inviteProvider.resolved": [ // <div className="buttonBar inviteProvider resolved">
                    { "id": "showProvider", "transKey": "button.showProvider", "transDefault": "Show Provider", "default": true },
                    //<button className="button single default showProvider" type="button"
                    //        data-i18n="button.showProvider">Show Provider
                    //</button>
                ] // </div>
                //<div className="title" data-i18n="requestDetail.headerText.default">Request</div>
            //</div>
        };
    },

    commandForGroup: function( group )
    {
        const commands = this._data()[ group ];
        return commands;
    }
};

const Commands =
{
    commandFromAction: function( actionKey )
    {
        const data = this._data();
        if( data[actionKey] )
        {
            return data[actionKey]();
        }
        else
        {
            return {};
        }
    },

    _data: function()
    {
        return {
            // close
            "close": () =>
            {
                let request = {};
                //     $('#requestDetail > .view > .header .button.close').click(function(request) {
                //             requestDetail.displayCommentDialog($.t("requestDetail.commentDialogLabel.close"))
                //                 .done(function(request){
                request.status = "CLOSED";
                request.pendingSide = "SENDER";
                //                     requestDetail.updateRequest(request).done(function() {
                //                         // load updated request in to the form and selected item
                //                         requestDetail.displayRequest();
                //                     });
                //                 });
                //         });
                return request;
            },
            "reject": () =>
            {
                let request = {};
                //         $('#requestDetail > .view > .header .button.reject').click(function(request) {
                //             requestDetail.displayCommentDialog($.t("requestDetail.commentDialogLabel.reject"))
                //                 .done(function(request){
                request.status = "CLOSED";
                request.pendingSide = "RECIPIENT";
                //                     requestDetail.updateRequest(request).done(function() {
                //                         // load updated request in to the form and selected item
                //                         requestDetail.displayRequest();
                //                     });
                //                 });
                //         });
                return request;
            },
            "return": () =>
            {
                let request = {};
                //
                // // return
                // $("#requestDetail > .view > .header .button.return").click(function(request) {
                //     requestDetail.displayCommentDialog($.t("requestDetail.commentDialogLabel.return"))
                //         .done(function(request){
                request.pendingSide = "SENDER";
                //             requestDetail.updateRequest(request).done(function() {
                //                 // load updated request in to the form and selected item
                //                 requestDetail.displayRequest();
                //             });
                //         });
                // });
                return request;
            },
            "dismiss": () =>
            {
                let request = {};
                //
                // // dismiss
                // $('#requestDetail > .view > .header .button.dismiss').click(function(request) {
                //     requestDetail.displayCommentDialog($.t("requestDetail.commentDialogLabel.dismiss"))
                //         .done(function(request){
                request.status = "DISMISSED";
                request.pendingSide = "RECIPIENT";
                //             requestDetail.updateRequest(request).done(function() {
                //                 // load updated request in to the form and selected item
                //                 requestDetail.displayRequest();
                //             });
                //         });
                // });
                //
                return request;
            },
            "accept": () =>
            {
                let request = {};
                // // accept
                // $('#requestDetail > .view > .header .button.accept').click(function(request) {
                //     requestDetail.displayCommentDialog($.t("requestDetail.commentDialogLabel.accept"))
                //         .done(function(request){
                request.status = "ACCEPTED";
                request.pendingSide = "RECIPIENT";
                //             requestDetail.updateRequest(request).done(function() {
                //                 // load updated request in to the form and selected item
                //                 requestDetail.displayRequest();
                //             });
                //         });
                // });
                //
                return request;
            },
            "resubmit": () =>
            {
                let request = {};
                // // resubmit
                // $("#requestDetail > .view > .header .button.resubmit").click(function(request){
                //     requestDetail.displayCommentDialog($.t("requestDetail.commentDialogLabel.resubmit"))
                //         .done(function(request){
                request.pendingSide = "RECIPIENT";
                //             requestDetail.updateRequest(request).done(function() {
                //                 // load updated request in to the form and selected item
                //                 requestDetail.displayRequest();
                //             });
                //         });
                // });
                //
                return request;
            },
            "resolving": () =>
            {
                let request = {};
                // $('#requestDetail > .view > .header .button.resolving').click(function(request) {
                //     requestDetail.displayCommentDialog($.t("requestDetail.commentDialogLabel.resolving"))
                //         .done(function(request){
                request.status = "RESOLVING";
                request.pendingSide = "SENDER";
                //             requestDetail.updateRequest(request).done(function() {
                //                 // load updated request in to the form and selected item
                //                 requestDetail.displayRequest();
                //             });
                //         });
                // });
                //
                return request;
            },
            "resolved": () =>
            {
                let request = {};
                // $('#requestDetail > .view > .header .button.resolved').click(function(request) {
                //     requestDetail.displayCommentDialog($.t("requestDetail.commentDialogLabel.resolved"))
                //         .done(function(request){
                request.status = "RESOLVED";
                request.pendingSide = "SENDER";
                //             requestDetail.updateRequest(request).done(function() {
                //                 // load updated request in to the form and selected item
                //                 requestDetail.displayRequest();
                //             });
                //         });
                // });
                //
                return request;
            },
            "notSolved": () =>
            {
                let request = {};
                // $('#requestDetail > .view > .header .button.notSolved').click(function(request) {
                //     requestDetail.displayCommentDialog($.t("requestDetail.commentDialogLabel.notResolved"))
                //         .done(function(request){
                request.status = "RESOLVING";
                request.pendingSide = "RECIPIENT";
                //             requestDetail.updateRequest(request).done(function() {
                //                 // load updated request in to the form and selected item
                //                 requestDetail.displayRequest();
                //             });
                //         });
                // });
                return request;
            }
        }
    }
};

export let RequestModelOriginal = {
    group: null,

    // private
    _enableButtonGroup: function( groupName )
    {
        this.group = groupName;
    },

    _setHeaderTextFromTranslationKey: function( translationKey )
    {
        this.titleKey = translationKey;
    },

    recalculateGivenRequest: function( request )
    {
        let requestDetail = {
            findCustomField: () => {} // stub
        };

        // clear
        RequestModelOriginal._enableButtonGroup('');
        RequestModelOriginal._setHeaderTextFromTranslationKey('');

        //
        // From old Touch
        //

        // BUTTONS & TITLE
        {
            var onMySide = (request.pendingSide == request.mySide || request.mySide == 'BOTH');
            if (request.status == 'INITIAL') {
                if (request.pendingSide == 'RECIPIENT') {
                    if (onMySide) {
                        if (request.type == "INVITE_PROVIDER")
                            RequestModelOriginal._enableButtonGroup("inviteProvider.recipient"); // $(".buttonBar.inviteProvider.recipient", header).show();
                        else
                            RequestModelOriginal._enableButtonGroup("initialRecipientYour"); // $(".buttonBar.initialRecipientYour", header).show();
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.initialRecipientYour"); // $(".title", header).text($.t("requestDetail.headerText.initialRecipientYour"));
                    } else {
                        if (request.type == "GENERIC")
                            RequestModelOriginal._enableButtonGroup("initialRecipientTheir"); // $(".buttonBar.initialRecipientTheir", header).show();
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.initialRecipientTheir"); // $(".title", header).text($.t("requestDetail.headerText.initialRecipientTheir"));
                    }
                } else if (request.pendingSide == 'SENDER') {
                    if (onMySide) {
                        RequestModelOriginal._enableButtonGroup("initialSenderYour"); // $(".buttonBar.initialSenderYour", header).show();
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.initialSenderYour"); // $(".title", header).text($.t("requestDetail.headerText.initialSenderYour"));
                    } else {
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.initialSenderTheir"); // $(".title", header).text($.t("requestDetail.headerText.initialSenderTheir"));
                    }
                }
            } else if (request.status == 'ACCEPTED') {
                if (request.pendingSide == 'RECIPIENT') {
                    if (onMySide) {
                        RequestModelOriginal._enableButtonGroup("acceptedRecipientYour"); // $(".buttonBar.acceptedRecipientYour", header).show();
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.acceptedRecipientYour"); // $(".title", header).text($.t("requestDetail.headerText.acceptedRecipientYour"));
                    } else {
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.acceptedRecipientTheir"); // $(".title", header).text($.t("requestDetail.headerText.acceptedRecipientTheir"));
                    }
                } else if (request.pendingSide == 'SENDER') {
                    if (onMySide) {
                        RequestModelOriginal._enableButtonGroup("acceptedSenderYour"); // $(".buttonBar.acceptedSenderYour", header).show();
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.acceptedSenderYour"); // $(".title", header).text($.t("requestDetail.headerText.acceptedSenderYour"));
                    } else {
                        RequestModelOriginal._enableButtonGroup("acceptedSenderTheir"); // $(".buttonBar.acceptedSenderTheir", header).show();
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.acceptedSenderTheir"); // $(".title", header).text($.t("requestDetail.headerText.acceptedSenderTheir"));
                    }
                }
            } else if (request.status == 'RESOLVING') {
                if (request.pendingSide == 'RECIPIENT') {
                    if (onMySide) {
                        if (request.type == "INVITE_PROVIDER")
                            RequestModelOriginal._enableButtonGroup("inviteProvider.recipient"); // $(".buttonBar.inviteProvider.recipient", header).show();
                        else
                            RequestModelOriginal._enableButtonGroup("resolvingRecipientYour"); // $(".buttonBar.resolvingRecipientYour", header).show();
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.resolvingRecipientYour"); // $(".title", header).text($.t("requestDetail.headerText.resolvingRecipientYour"));
                    } else {
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.resolvingRecipientTheir"); // $(".title", header).text($.t("requestDetail.headerText.resolvingRecipientTheir"));
                    }
                } else if (request.pendingSide == 'SENDER') {
                    if (onMySide) {
                        RequestModelOriginal._enableButtonGroup("resolvingSenderYour"); // $(".buttonBar.resolvingSenderYour", header).show();
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.resolvingSenderYour"); // $(".title", header).text($.t("requestDetail.headerText.resolvingSenderYour"));
                    } else {
                        RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.resolvingSenderTheir"); // $(".title", header).text($.t("requestDetail.headerText.resolvingSenderTheir"));
                    }
                }
            } else if (request.status == 'RESOLVED') {
                if (request.type == "CREATE_PROVIDER") {
                    // display links to organization if we have it in the request
                    var org = requestDetail.findCustomField(requestDetail.request, "hostName");
                    if (org) {
                        RequestModelOriginal._enableButtonGroup("createProvider.resolved"); // $(".buttonBar.createProvider.resolved .button", header).data('organization', org);
                        RequestModelOriginal._enableButtonGroup("createProvider.resolved"); // $(".buttonBar.createProvider.resolved", header).show();
                    }
                }
                else if (request.type == "CREATE_PROJECT") {
                    // display link to project detail if we have it in the request
                    var project = requestDetail.findCustomField(requestDetail.request, "projectIdent");
                    if (project) {
                        RequestModelOriginal._enableButtonGroup("createProject.resolved"); // $(".buttonBar.createProject.resolved .button", header).data('project', project.value);
                        RequestModelOriginal._enableButtonGroup("createProject.resolved"); // $(".buttonBar.createProject.resolved", header).show();
                    }
                }
                else if (request.type == "INVITE_PROVIDER") {
                    if (request.pendingSide == 'SENDER' && onMySide)
                        RequestModelOriginal._enableButtonGroup("inviteProvider.resolved"); // $(".buttonBar.inviteProvider.resolved", header).show();
                }
                RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.resolved"); // $(".title", header).text($.t("requestDetail.headerText.resolved"));
            } else if (request.status == 'DISMISSED') {
                RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.dismissed"); // $(".title", header).text($.t("requestDetail.headerText.dismissed"));
            } else if (request.status == 'CLOSED') {
                if (request.pendingSide == 'RECIPIENT')
                    RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.closedRecipient"); // $(".title", header).text($.t("requestDetail.headerText.closedRecipient"));
                else if (request.pendingSide == 'SENDER')
                    RequestModelOriginal._setHeaderTextFromTranslationKey("requestDetail.headerText.closedSender"); // $(".title", header).text($.t("requestDetail.headerText.closedSender"));
            }
        }
    },

    getButtonsAsReact: function()
    {
        return CommandGroups.getButtonsForGroup( this.group );
    },

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    getHeaderForRequest( request )
    {
        log({ request });
        this.recalculateGivenRequest( request );
        const t = TranslationOld.getTranslationForKey( this.titleKey );
        return t;
        return this.titleKey;
    },

    getCommandsForRequest( request )
    {
        this.recalculateGivenRequest( request );
        const commandList = CommandGroups.commandForGroup( this.group );
        log( { commandList });

        let ret = [];

        forEach( commandList, ( cmd, uniqueKey ) =>
        {
            log( {cmd} );
            let command = {};
            command.id = cmd.id;
            command.isPrimary = !! cmd.default;
            command.name = TranslationOld.getTranslationForKey( cmd.transKey );
            command.formData = Commands.commandFromAction( cmd.id );
            // primaryButtonLabel ???
            ret.push( command );
        });
        return ret;
    },




};


// WEBPACK FOOTER //
// ./src/pages/RequestDetail/RequestOldModel.js